import {NOTIFICATION_ADDED} from '@packages/systems/designer/actions';
import {type Notification} from '@packages/systems/core/records/NotificationRecord';
import {ActionCreator, createAction} from '@packages/utilities/create-action';

export const notificationAdded: ActionCreator<
  typeof NOTIFICATION_ADDED,
  Notification
> = createAction(NOTIFICATION_ADDED);
